import React from "react";
import Box from "@mui/material/Box";
import { useQuery } from "@apollo/client/react";

import { heightOptions } from "../../../constants/warehouse";
import { WAREHOUSE_PROJECTS } from "../../../constants/graphql/queries";

export default function FiltersStatus({
  warehouse,
  occupied,
  selected = [],
  height,
  locationTypes,
  active,
}) {
  const { data } = useQuery(WAREHOUSE_PROJECTS, {
    variables: { id: warehouse.id },
    skip: selected.length === 0,
  });
  const projects = data?.warehouse?.projects || [];

  const heightLabel =
    height &&
    heightOptions.find(option => option.type === height.type && option.value === height.value)
      ?.label;

  const occupiedLabel =
    typeof occupied === "boolean" ? (occupied ? "Which Are Occupied" : "Which Are Empty") : null;

  const projectLabels = selected
    .map(project => projects.find(p => p.id === project)?.name)
    .map(name => `Where ${name} is Located`);

  const labels = [heightLabel, occupiedLabel, ...projectLabels].filter(Boolean);
  const types = locationTypes.map(type => type.charAt(0).toUpperCase() + type.slice(1));
  const activeLabel = typeof active === "boolean" ? (active ? "Active" : "Inactive") : null;

  return (
    <Box>
      Viewing All {activeLabel} {types} Locations {labels.join(", and ")}
    </Box>
  );
}
